import * as React from "react";
import { useCallback } from "react";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import SearchFiltersOverviewPopover from "search-filter/components/search-filter-bar/SearchFiltersOverviewPopover";
const SearchFiltersOverview = ({ showPopover, onChange, isParentMutable = true }) => {
  const onClose = useCallback(() => onChange(false), [onChange]);
  const onClick = useCallback(() => onChange(), [onChange]);
  return /* @__PURE__ */ React.createElement(SearchFiltersOverviewPopover, { show: showPopover, onClose, isParentMutable }, /* @__PURE__ */ React.createElement(Button, { title: "Load filter", onClick, bsSize: "small" }, /* @__PURE__ */ React.createElement(Icon, { name: "folder", type: "regular" })));
};
export default SearchFiltersOverview;
